module.exports = __webpack_public_path__ + "static/media/DC_O_Embroidery_Vela_Dark grey_White.653dbabe.png";